/**
 * The view a device-like page was opened from, carried in the `origin` query parameter (not `from`, which holds the date range).
 * A closed set, so the parameter can never be used to navigate anywhere arbitrary.
 */
export type DeviceOrigin = 'hierarchy'

export type HierarchyTopology = 'electrical' | 'heating'

export interface ResolvedDeviceOrigin {
  /** Where Back and the parent-view breadcrumb lead. */
  path: string
  /** Translation key (common namespace) for the parent-view breadcrumb. */
  labelKey: 'deviceView'
}

/**
 * Build the query string that links opened from the given origin append.
 */
export function getDeviceOriginSearch(origin: DeviceOrigin, topology: HierarchyTopology): string {
  const params = new URLSearchParams({ origin })
  if (topology === 'heating') params.set('topology', 'heating')
  return `?${params}`
}

/**
 * Resolve the originating view of a device-like page from its query parameters.
 * Returns null when the page should fall back to its default (monitoring) behaviour.
 */
export function resolveDeviceOrigin(
  searchParams: URLSearchParams,
  projectId: number | null | undefined
): ResolvedDeviceOrigin | null {
  if (searchParams.get('origin') !== 'hierarchy' || projectId == null) {
    return null
  }

  const search = searchParams.get('topology') === 'heating' ? '?topology=heating' : ''
  return { path: `/projects/${projectId}${search}#assets`, labelKey: 'deviceView' }
}
